<template>
  <div class="gy-logo">
    <router-link to="/" style="font-size: 0">
      <img :src="require('@/assets/logo.png')" alt="logo" />
    </router-link>
    <span v-if="title" class="gy-logo__title">
      <gy-divider />
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  name: "GyLogo",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="less">
.gy-logo {
  display: flex;
  align-items: center;
  img {
    height: 48px;
  }
  &__title {
    position: relative;
    top: -2px;
    font-size: 24px;
    color: #ffffff;
  }
}
</style>
